import { mediaQueriesV2 } from "@ui/themes/default";

import { Props, SourceProps } from "./Image.types";

export const areStaticSources = (
  sources: Props["sources"],
): sources is SourceProps[] => Array.isArray(sources);

export const isNotMediaQuery = (media: SourceProps["media"]): media is string =>
  !Object.keys(mediaQueriesV2).includes(media);
